import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';
/**
 * カナチェッククラス
 */
export default class EFOcats_validate_kana extends efocats_validate_core {
  /**
   * 初期化
   * @param {*} allowSpace 空白文字を許容するか（デフォルトは許容しない）
   */
  constructor(allowSpace = false) {
    super();
    this.allowSpace = allowSpace;
  }

  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    let pattarn = /^[ァ-ヶー]+$/;

    if (this.allowSpace) {
      // eslint-disable-next-line no-irregular-whitespace
      pattarn = /^[ァ-ヶー\s　]+$/;
    }

    if (!checkData.val().match(pattarn)) {
      result = new EFOcats_error_info('error', EFOcats_import_lang.getValue('kana_error'), '', EFOcats_import_lang.getValue('kana_error'));
    }

    return result;
  }
}
